import { render } from "./NutritionTracker.vue?vue&type=template&id=39019ae6"
import script from "./NutritionTracker.vue?vue&type=script&lang=js"
export * from "./NutritionTracker.vue?vue&type=script&lang=js"

import "./NutritionTracker.vue?vue&type=style&index=0&id=39019ae6&lang=css"
import "./NutritionTracker.vue?vue&type=style&index=1&id=39019ae6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__